import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

export const CheckIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path d="M21.6970574,5.74336718 C21.2926309,5.33944369 20.6374594,5.33944369 20.2330329,5.74336718 L9.91580397,16.0605961 L3.74204046,9.88683262 C3.33389564,9.50651932 2.69787374,9.51774118 2.30339915,9.91221577 C1.90892456,10.3066904 1.8977027,10.9427123 2.27801601,11.3508571 L9.18379175,18.2566328 C9.58821821,18.6605563 10.2433897,18.6605563 10.6478162,18.2566328 L21.6970574,7.20739164 C22.1009809,6.80296518 22.1009809,6.14779364 21.6970574,5.74336718 L21.6970574,5.74336718 Z" />
    </SvgIcon>
);

export default CheckIcon;
